<template>
  <div :id="componentId" class="sp6-title-wrapper" :style="{ backgroundColor: backgroundColor }">
    <div class="sp6-title-content">
      <span class="sp6-text_44" :style="{ color: titleColor }">{{ title }}</span>
      <div class="sp6-group_13 flex-row justify-between">
        <div class="sp6-group_14 flex-col" style="margin-left: calc(50% - 68px - 60px);" ></div>
        <span class="sp6-text_45" :style="{ color: subTitleColor }">{{ subTitle }}</span>
        <div class="sp6-group_15 flex-col" style="margin-right: calc(50% - 68px - 60px);" ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpecialSixTitle',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_title'
    }
  },
  data() {
    return {
      title: '标题内容',
      titleColor: '#00000f',
      subTitle: 'CHINA BRAND',
      subTitleColor: 'rgba(52, 54, 56, 1)',
      backgroundColor: '#F3F3F3'
    };
  }
};
</script>
<style scoped>
.sp6-title-wrapper {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding: 20px 0;
}

.sp6-title-content {
  position: relative;
  width: 1400px;
  margin: 0 auto;
  text-align: center;
}

/* 标题居中 */
.sp6-title-content .sp6-text_44 {
  display: block;
  width: auto !important;
  margin: 20px 0 0 0 !important;
  text-align: center !important;
  color: inherit;
  font-size: 40px;
  font-family: Microsoft YaHei-Bold;
  font-weight: 700;
  line-height: 53px;
  white-space: nowrap;
  overflow-wrap: break-word;
}

/* 副标题组居中 */
.sp6-title-content .sp6-group_13 {
  display: flex !important;
  flex-direction: row !important;
  align-items: center;
  justify-content: center;
  width: auto !important;
  height: auto !important;
  margin: 10px 0 40px 0 !important;
}

/* 左侧红色装饰条 */
.sp6-title-content .sp6-group_14 {
  box-shadow: 0px 4px 8px 1px rgba(219, 79, 81, 0.3);
  background-image: linear-gradient(90deg, rgba(203, 47, 48, 1) 0, rgba(233, 110, 116, 1) 100%) !important;
  border-radius: 3px;
  width: 20px;
  height: 6px;
  margin: 0 ;
  flex-shrink: 0;
}

/* 副标题文字 */
.sp6-title-content .sp6-text_45 {
  width: auto !important;
  height: auto !important;
  margin: 0 10px !important;
  color: inherit;
  font-size: 14px;
  font-family: Microsoft YaHei-Regular;
  text-align: center;
  white-space: nowrap;
  line-height: 14px;
  overflow-wrap: break-word;
}

/* 右侧红色装饰条 */
.sp6-title-content .sp6-group_15 {
  box-shadow: 0px 4px 8px 1px rgba(219, 79, 81, 0.3);
  background-image: linear-gradient(90deg, rgba(203, 47, 48, 1) 0, rgba(233, 110, 116, 1) 100%) !important;
  border-radius: 3px;
  width: 20px;
  height: 6px;
  margin: 0 ;
  flex-shrink: 0;
}
</style>

